import React, { MouseEventHandler } from "react"
import styled from "styled-components"
import { theme } from "../../../theme"
import { TextBold, TextDisclaimer, TextRegular } from "../../atoms/text"
import { Avatar, AvatarIdentities, AvatarOrganization, AvatarSize } from "../../atoms/avatar"
import { Individual, Organization } from "../../common"
import { formatFullName } from "../../formatters"

export type ProfileBaseProps = {
  onClick?: MouseEventHandler<HTMLElement>
  noWrap?: boolean
}

export type ProfileProps = ProfileBaseProps & {
  individual: Individual
  starredLabel?: string
  identity?: AvatarIdentities
  size?: AvatarSize
  dataCy?: string
  nonBoldTitle?: boolean
}

export type ProfileOrganizationProps = ProfileBaseProps & {
  organization: Organization
  organizationIcon?: boolean
}

export const Profile = (props: ProfileProps) => {
  const { dataCy, individual, starredLabel, identity, size = AvatarSize.medium, onClick, noWrap, nonBoldTitle } = props
  const title = formatFullName(individual.firstName, individual.lastName, individual.title)
  return (
    <Wrapper data-cy={dataCy}>
      <AvatarWrapper>
        <Avatar individual={individual} starredLabel={starredLabel} identity={identity} size={size} onClick={onClick} />
      </AvatarWrapper>
      <Info>
        {nonBoldTitle ? (
          <TextRegular noWrap={noWrap}>{title}</TextRegular>
        ) : (
          <TextBold noWrap={noWrap}>{title}</TextBold>
        )}
        <TextDisclaimer noWrap={noWrap}>{individual.organization}</TextDisclaimer>
      </Info>
    </Wrapper>
  )
}

export const ProfileOrganization = (props: ProfileOrganizationProps) => {
  const { organization, onClick, organizationIcon = false, noWrap } = props

  return (
    <Wrapper>
      <AvatarWrapper>
        <AvatarOrganization organization={organization} onClick={onClick} organizationIcon={organizationIcon} />
      </AvatarWrapper>
      <Info>
        <TextBold noWrap={noWrap}>{organization.name}</TextBold>
        {organization.id && <TextDisclaimer noWrap={noWrap}>{organization.id}</TextDisclaimer>}
      </Info>
    </Wrapper>
  )
}

const Info = styled.div`
  margin-right: ${theme.spacing.s};
  flex-grow: 1;
  width: 90%;
`

const AvatarWrapper = styled.span`
  margin-right: ${theme.spacing.m};
  z-index: ${theme.zIndex.medium};
`

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: left;
  padding: 5px ${theme.spacing.m} 5px 0px;
  width: 100%;
`
